import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from 'apps/sigma2-ui/src/lib/hooks/useAnalytics';

export const PageViewTracker = () => {
  const location = useLocation();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    // Track page view when location changes
    trackEvent({
      eventName: 'Page Viewed',
      eventProperties: {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        fullUrl: `${location.pathname}${location.search}${location.hash}`,
      },
    });
  }, [location, trackEvent]);

  return null;
};
